module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAASCAYAAAC0EpUuAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADDSURBVHgBrVOBDcMgDIt6QU/glJ6yE/bB2CX0k54S7YLtgyzRUglFQMrAEqpEE2McA+CAiB4wE0wY6IcNZoHJkpImmIFM5Yn1au/S+Ge9vMMIxENeaJS+//KWm268DmoDpc4jWiU2qqQHqCKC5RRPZQAvXh/og/QFt09PRkfh4V6/Qr4V7EAqDIp6XhwXR0OaCjV9L04HmCMUalLtwBbxbpuonhY807A4vLt+n9leLS3X0qDKInTcZBiakqLfo8TR7n0BCDiDbc9DBzQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/awards/magic_button.png
// module id = 2157
// module chunks = 1612